import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export interface Public {
  isSidebarCollapsed: false;
  search: {
    [key: string]: string;
  };
  page: number;
  modalId: string;
  modalExtraData: object;
}

const initialState: Public = {
  isSidebarCollapsed: false,
  search: {},
  page: 0,
  modalId: '',
  modalExtraData: {},
};

export const publicSlice = createSlice({
  name: 'public',
  initialState,
  reducers: {
    setSidebarCollapseFlag: (state, action) => {
      state.isSidebarCollapsed = action.payload;
    },

    setSearch: (state, action) => {
      state.search[action.payload.key] = action.payload.value;
    },

    setPage: (state, action) => {
      state.page = action.payload;
    },

    setModalId: (state, action) => {
      state.modalId = action.payload?.id;
      if (action.payload && 'extraData' in action.payload) {
        state.modalExtraData = action.payload?.extraData;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSearch, setPage, setModalId, setSidebarCollapseFlag } =
  publicSlice.actions;
export const usePublicState = () =>
  useSelector((state: RootState) => state?.public);

export default publicSlice.reducer;
